import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { SiteNav } from "@/components/layout/SiteNav";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/admin/rum/")({
  component: AdminGSCPanel,
});

function AdminGSCPanel() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/public/gsc")
      .then(res => res.json())
      .then(d => {
        setData(d);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0C10] text-white">
      <SiteNav />
      <main className="container-page py-20">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h1 className="font-display text-4xl">SEO Monitoring Panel</h1>
            <p className="mt-2 text-muted-foreground">Importing Google Search Console data & highlighting opportunities.</p>
          </div>
          <div className="flex gap-4">
            <Link to="/admin/conversions/" search={{}} className="text-sm border border-white/10 px-4 py-2 rounded-lg hover:bg-white/5">Conversions</Link>
            <Link to="/admin/rum/" search={{}} className="text-sm border border-white/10 px-4 py-2 rounded-lg hover:bg-white/5 bg-white/5">RUM & GSC</Link>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-3 mb-12">
          <div className="surface-card p-6 border-l-4 border-red-500">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Top CTR Drops</div>
            <div className="mt-4 text-2xl font-display">0</div>
            <p className="mt-1 text-xs text-muted-foreground">Significant drops in the last 7 days.</p>
          </div>
          <div className="surface-card p-6 border-l-4 border-yellow-500">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Indexing Errors</div>
            <div className="mt-4 text-2xl font-display">0</div>
            <p className="mt-1 text-xs text-muted-foreground">URLs with indexing issues in GSC.</p>
          </div>
          <div className="surface-card p-6 border-l-4 border-green-500">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Content Opportunities</div>
            <div className="mt-4 text-2xl font-display">Active</div>
            <p className="mt-1 text-xs text-muted-foreground">High-impression, low-CTR keywords found.</p>
          </div>
        </div>

        <div className="surface-card p-8 text-center py-20">
          <div className="max-w-md mx-auto">
            <h2 className="text-xl font-display mb-4">GSC Data Integration</h2>
            <p className="text-sm text-muted-foreground mb-8">
              Connect your Google Search Console account to see real-time performance data, 
              indexing errors, and AI-discovered content opportunities directly in this dashboard.
            </p>
            <button className="bg-primary text-primary-foreground px-6 py-3 rounded-full font-medium hover:bg-primary/90 transition-colors">
              Link Search Console account
            </button>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
